import ShareHeader from './ShareHeader.vue'
import { isInHeybox } from '_lib/utils';

export const mountShareHeader = (Vue, config) => {

  const instance = new Vue({
    data() {
      return {
        config,
      };
    },
    watch: {
      '$hbShareConfig.shareConfig': {
        handler(newConfig) {
          this.config = {
            ...newConfig['share-header'],
            protocol: newConfig['share-header'].protocol || newConfig['open-app'].protocol
          };
        },
        deep: true,
        immediate: true,
      }
    },
    render(h) {
      return h(ShareHeader, { props: this.config });
    }
  });
  instance.$mount();
  document.body.insertBefore(instance.$el, document.body.firstChild);
}

export default {
  install(Vue, config) {
    if(isInHeybox()) return
    mountShareHeader(Vue, config)
  }
}